import { render, staticRenderFns } from "./CallForwardingList.vue?vue&type=template&id=f926f432&"
import script from "./CallForwardingList.vue?vue&type=script&lang=ts&"
export * from "./CallForwardingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports